import React from 'react';
import * as Sentry from '@sentry/react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import { createEmotionCache } from '../utils/emotionCache';
// Import Swiper styles
import 'swiper/swiper-bundle.min.css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

import './utils/polyfills';
import { isProduction } from './config.client';

declare global {
    interface Window {
        CURRENT_PAGE_COMPONENT: string
        APP_PROPS?: any
    }
}

Sentry.init({
    dsn: 'https://28fd2351c42fe951e36c7445a6af82db@o4511599592734720.ingest.de.sentry.io/4511599597781072',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error', 'warn'],
        }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    enabled: isProduction,
});

const ReactComponent = require(`./pages/${window.CURRENT_PAGE_COMPONENT}.page`);
const container = document.getElementById('container');
const component = React.createElement(ReactComponent.default, window.APP_PROPS);
const cache = createEmotionCache();
const tree = (
    <CacheProvider value={cache}>
        {component}
    </CacheProvider>
);

if (!isProduction) {
    createRoot(container).render(tree);
} else {
    hydrateRoot(container, tree);
}
